export const THEME_PRESETS = {
  obsidian: { 
    preset: 'obsidian', 
    primary_color: '#ffffff', 
    accent_color: '#a1a1aa', 
    bg_color: '#09090b', 
    text_color: '#fafafa',
    name_color: '#ffffff',
    label: 'Obsidian Glass' 
  },
  paper: { 
    preset: 'paper', 
    primary_color: '#1a1a1a', 
    accent_color: '#ef4444', 
    bg_color: '#ffffff', 
    text_color: '#18181b',
    name_color: '#0f0f0f',
    label: 'Swiss Paper' 
  },
  botanical: { 
    preset: 'botanical', 
    primary_color: '#166534', 
    accent_color: '#16a34a', 
    bg_color: '#f0fdf4', 
    text_color: '#14532d',
    name_color: '#052e16',
    label: 'Botanical' 
  },
  ocean: { 
    preset: 'ocean', 
    primary_color: '#38bdf8', 
    accent_color: '#0ea5e9', 
    bg_color: '#0c1929', 
    text_color: '#e0f2fe',
    name_color: '#ffffff',
    label: 'Deep Ocean' 
  },
  dusk: { 
    preset: 'dusk', 
    primary_color: '#e9d5ff', 
    accent_color: '#c084fc', 
    bg_color: '#1e1030', 
    text_color: '#f3e8ff',
    name_color: '#ffffff',
    label: 'Dusk' 
  },
  clay: { 
    preset: 'clay', 
    primary_color: '#92400e', 
    accent_color: '#d97706', 
    bg_color: '#fffbeb', 
    text_color: '#451a03',
    name_color: '#1c0a00',
    label: 'Warm Clay' 
  },
};

export const ICON_OPTIONS = [
  // Core
  'globe', 'mail', 'phone', 'link',
  // Social
  'linkedin', 'instagram', 'facebook', 'twitter', 'youtube', 'github', 
  'twitch', 'tiktok', 'discord', 'threads', 'mastodon', 'snapchat',
  // Messaging
  'message-square',
  // Professional
  'briefcase', 
  // Creative
  'music', 'camera', 'video',
  // Other
  'heart', 'star', 'coffee',
];

// Social platform URL patterns for auto-detection
export const SOCIAL_PATTERNS = {
  linkedin: /linkedin\.com/i,
  instagram: /instagram\.com/i,
  facebook: /facebook\.com/i,
  twitter: /twitter\.com|x\.com/i,
  youtube: /youtube\.com|youtu\.be/i,
  github: /github\.com/i,
  twitch: /twitch\.tv/i,
  tiktok: /tiktok\.com/i,
  discord: /discord\.gg|discord\.com/i,
  threads: /threads\.net/i,
  mastodon: /mastodon/i,
  snapchat: /snapchat\.com/i,
};
